import { KatDropdown } from '@amzn/katal-react';
import { StyledDropdown } from 'src/components/general/StyledDropdown';
import { useSelection } from 'src/contexts/SelectionContext';
import styles from './MarketplaceSelector.module.css';
import { MarketPlace } from '@amzn/fire-tv-campaign-automation-service';
import { CMSConfig } from 'src/configs/campaignMetadataConfig';

interface MarketplaceSelectorProps {
  className?: string;
}

const MarketplaceSelector = ({ className }: MarketplaceSelectorProps) => {
  const { setMarketplace } = useSelection();
  // ToDo: The list of applicable marketplaces needs to be passed from CDK
  const marketplaceOptions = CMSConfig?.MARKET_PLACE.map((marketplace) => ({
    name: `${marketplace} Marketplace`,
    value: marketplace,
  }));

  const handleMarketplaceChange = (event: KatDropdown.ChangeEvent) => {
    setMarketplace(event.detail.value as MarketPlace);
  };

  return (
    <StyledDropdown
      value={CMSConfig?.MARKET_PLACE?.[0]}
      onChange={handleMarketplaceChange}
      options={marketplaceOptions}
      className={`${styles.container} ${className || ''}`}
    />
  );
};

export { MarketplaceSelector };
